import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IpProfileApiService {

  constructor(private http: HttpClient) {}

  readonly ipProfileUrl: string = 'topology/ipProfile';
  readonly ipProfileDefinitionUrl: string = 'topology/ipProfileDefinition';

  public getIpProfiles(): Observable<any> {
    return this.http.get(this.ipProfileUrl);
  }

  public getIpProfile(id: number): Promise<any> {
    return this.http.get(`${this.ipProfileUrl}/${id}`).toPromise();
  }

  public getIpProfileDefinition(id: number): Promise<any> {
    return this.http.get(`${this.ipProfileDefinitionUrl}/${id}`).toPromise();
  }

  public getIpProfilesDefinition(): Promise<any> {
    return this.http.get(this.ipProfileDefinitionUrl).toPromise();
  }

  public addIpProfilesDefinition(ipProfileDefinition: any): Promise<any> {
    return this.http.post(this.ipProfileDefinitionUrl, ipProfileDefinition).toPromise();
  }

  public editIpProfilesDefinition(ipProfileDefinition: any, id: number): Promise<any> {
    return this.http.put(`${this.ipProfileDefinitionUrl}/${id}`, ipProfileDefinition).toPromise();
  }

  public getIpProfilesDefinitionEnum(): Promise<any> {
    return this.http.get(`${this.ipProfileDefinitionUrl}/enum`).toPromise();
  }

  public deleteIpProfileDefinition(id: number): Promise<any> {
    return this.http.delete(`${this.ipProfileDefinitionUrl}/${id}`).toPromise();
  }

  public restoreIpProfileDefinition(id: number): Promise<any> {
    return this.http.put(`${this.ipProfileDefinitionUrl}/${id}/restore`, {}).toPromise();
  }
}
